module.exports = "https://www.gc-qa.gnp.com.mx/1bb7ecce8bfb6d6c2757f9ef2a550118.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videos/directorio/1.png
// module id = 1022
// module chunks = 0 1